<template><div></div></template>

<script>
export default {
  data: () => ({
    icon: "❄",
    intervalTheme: null,
  }),
  mounted() {
    const iconFall = this.icon;
    const body = document.body;

    const createContentIconFall = () => {
      const contentIconFall = document.createElement("div");
      contentIconFall.classList.add("contentIconFall");
      contentIconFall.textContent = iconFall;

      // --- เพิ่มการสุ่มสำหรับ Sway & Flip ---
      const duration = Math.random() * 3 + 8; // 8s - 11s (สำหรับ Fall)
      const swayIntensity = Math.random() * 30 + 10; // 10px - 40px (สำหรับ Sway)
      const useFlip = false;
      const flipDuration = Math.random() * 2 + 4; // 4s - 6s (สำหรับ Flip)
      const flipDelay = Math.random() * 5; // 0s - 5s (สำหรับ Flip)

      // กำหนด Style
      contentIconFall.style.left = `${Math.random() * 100}vw`;
      contentIconFall.style.fontSize = `${Math.random() * 2 + 0.5}em`;
      contentIconFall.style.fontWeight = `700`;
      contentIconFall.style.color = `#e3f2fd`; // สีชมพูสุ่ม

      // กำหนด CSS Variable สำหรับการส่าย
      contentIconFall.style.setProperty(
        "--sway-intensity",
        `${swayIntensity}px`
      );

      // รวม Animation ทั้ง 3 ตัว: fall, sway, flipAndSpin
      contentIconFall.style.animation = `fall ${duration}s linear infinite, 
           sway 5s ease-in-out infinite alternate
           ${
             useFlip
               ? `, flipAndSpin ${flipDuration}s linear infinite ${flipDelay}s`
               : ""
           }`;

      // สำคัญ: ต้องเปิด transform-style เพื่อให้การหมุน 3D ทำงาน
      contentIconFall.style.transformStyle = "preserve-3d";

      body.appendChild(contentIconFall);

      // ลบ Element ออกจาก DOM เมื่อ Animation ใกล้จบ
      setTimeout(() => {
        contentIconFall.remove();
      }, (duration + 1) * 1000);
    };

    this.intervalTheme = setInterval(createContentIconFall, 800); // สร้างหัวใจทุก 800ms
  },
  beforeDestroy() {
    if (this.intervalTheme) {
      clearInterval(this.intervalTheme);
    }
  },
  methods: {},
};
</script>

<style>
@keyframes fall {
  0% {
    top: -10px;
    opacity: 1;
  }
  100% {
    top: 100vh;
    opacity: 0;
  }
}

/* Keyframe สำหรับการส่าย (Sway) ที่ใช้ CSS Variable */
@keyframes sway {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    /* ใช้ CSS Variable ที่ถูกกำหนดใน JS เพื่อให้ความกว้างของการส่ายสุ่ม */
    transform: translateX(var(--sway-intensity, 20px));
  }
}

/* Keyframe ใหม่: สำหรับการพลิก (Flip) และหมุน (Spin) ใน 3 มิติ */
@keyframes flipAndSpin {
  0% {
    transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(720deg) rotateY(1080deg) rotateZ(360deg);
  }
}

.contentIconFall {
  position: fixed;
  top: -10px;
  z-index: 9999;
  /* color, font-size, font-weight ถูกกำหนดใน JS แล้ว */
  line-height: 1; /* ช่วยให้การหมุนไม่บิดเบือน */
  cursor: pointer;
  /* animation ถูกกำหนดใน JS แล้ว */
}

@keyframes floatUp {
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  50% {
    opacity: 0.7;
    /* ปรับให้พุ่งออกไปในทิศทางสุ่มมากขึ้น */
    transform: translateY(-50px) scale(1.3);
  }
  100% {
    opacity: 0;
    /* ปรับให้พุ่งขึ้นไปไกลกว่าเดิม */
    transform: translateY(-150px) scale(0.8);
  }
}
</style>